"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
var libzl_1 = require("../libzl/libzl");
var ScreenshotManager_1 = require("../ScreenshotManager");
var utils_1 = require("../utils");
function parentEvent(type, data) {
    window.parent.postMessage(JSON.stringify({ event: type, params: data }), "*");
}
function takePhoto(title, config) {
    utils_1.ZLTagger.UCXX_takephoto();
    var maxSize = window.zlurlparams.screenshotSize > 0 ? window.zlurlparams.screenshotSize : 1920;
    var viewport = document.getElementById("streamContainer");
    var rect = viewport === null || viewport === void 0 ? void 0 : viewport.getBoundingClientRect();
    if (rect) {
        var width = Math.min(Math.max(rect.right, 0) - Math.max(rect.left, 0), window.innerWidth);
        var height = Math.min(Math.max(rect.bottom, 0) - Math.max(rect.top, 0), window.innerHeight);
        var aspect = width / height;
        if (true) {
            var stdAspects = [9 / 16, 1.0, 16 / 9].sort();
            aspect = Math.max(Math.min(aspect, stdAspects[stdAspects.length - 1]), stdAspects[0]);
            for (var index = 1; index < stdAspects.length; ++index) {
                if (aspect <= stdAspects[index]) {
                    if (aspect <= ((stdAspects[index - 1] + stdAspects[index]) / 2)) {
                        aspect = stdAspects[index - 1];
                    }
                    else {
                        aspect = stdAspects[index];
                    }
                    break;
                }
            }
        }
        if (aspect >= 1) {
            width = maxSize;
            height = Math.round(maxSize / aspect);
        }
        else {
            width = Math.round(maxSize * aspect);
            height = maxSize;
        }
        config = __assign({ width: width, height: height }, (config || {}));
    }
    else {
        config = __assign({ width: maxSize, height: maxSize }, (config || {}));
    }
    var format = ScreenshotManager_1.ScreenshotFormat();
    var mimeType = {
        jpg: "image/jpeg",
        png: "image/png"
    };
    return new Promise(function (resolve, reject) {
        if (ScreenshotManager_1.SupportScreenshotManagment()) {
            libzl_1.screenshotCapture(config.width, config.height, format).catch(function (reason) {
                reject(reason);
                return undefined;
            }).then(function (image) {
                if (image) {
                    var reader_1 = new FileReader();
                    reader_1.onerror = function () {
                        reject("Failed to process image");
                    };
                    reader_1.onabort = function () {
                        reject("Aborted image processing");
                    };
                    reader_1.onloadend = function () {
                        ScreenshotManager_1.SaveScreenshot(reader_1.result, format, title, config).then(function () {
                            resolve({ imageURL: reader_1.result, imageAspect: config.width / config.height });
                        });
                    };
                    reader_1.readAsDataURL(new Blob([image.blob], { type: mimeType[format] }));
                }
            });
        }
        else {
            libzl_1.screenshotDownload(config.width, config.height);
            resolve(undefined);
        }
    });
}
exports.takePhoto = takePhoto;
function viewCinematic() {
    console.log("viewCinematic");
}
exports.viewCinematic = viewCinematic;
function changeEnvironment() {
    console.log("changeEnvironment");
}
exports.changeEnvironment = changeEnvironment;
function share() {
    console.log("share");
}
exports.share = share;
function comment() {
    console.log("comment");
}
exports.comment = comment;
function finalize() {
    var ir = {
        size: [512, 512],
        background_colour: "#00000000"
    };
    libzl_1.requestImage(ir).then(function (result) {
        console.log("result of image request:", result);
    });
    parentEvent("finalize");
}
exports.finalize = finalize;
//# sourceMappingURL=actions.js.map